import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingOverviewComponent } from './reporting-overview/reporting-overview.component';
import { ReportingMainPageComponent } from './reporting-main-page/reporting-main-page.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from "@angular/material/card";
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ReportingMenuComponent } from "./shared/components/reporting-menu/reporting-menu.component";
import { ReportingContainerComponent } from './shared/components/reporting-container/reporting-container.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReportingVisualizerComponent } from './shared/components/reporting-visualizer/reporting-visualizer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltip } from "@angular/material/tooltip";
import { UserModule } from '../user/user.module';

@NgModule({
  declarations: [
    ReportingOverviewComponent,
    ReportingMainPageComponent,
    ReportingMenuComponent,
    ReportingContainerComponent,
    ReportingVisualizerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MatCardModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTooltip,
    UserModule
]
})
export class ReportingModule { }
